import { BasicSearchComponent } from './basic-search/basic-search.component';
import { CollapsibleContainerComponent } from './collapsible-container/collapsible-container.component';
import { AddressComponent } from './entity-forms/addresses/address/address.component';
import {
    MultiAddressContainerComponent,
} from './entity-forms/addresses/multi-address-container/multi-address-container.component';
import {
    SingleAddressContainerComponent,
} from './entity-forms/addresses/single-address-container/single-address-container.component';
import { AdminDataComponent } from './entity-forms/admin-data/admin-data.component';
import { EducationLevelComponent } from './entity-forms/education-level/education-level.component';
import { GeneralDataComponent } from './entity-forms/general-data/general-data.component';
import { ImportContactsComponent } from './entity-forms/import-contacts/import-contacts.component';
import { PasswordComponent } from './entity-forms/password/password.component';
import { PersonalDataComponent } from './entity-forms/personal-data/personal-data.component';
import { RoleComponent } from './entity-forms/role/role.component';
import { SchedulesComponent } from './entity-forms/schedules/schedules.component';
import { SchoolImportsComponent } from './entity-forms/school-imports/school-imports.component';
import { SchoolSelectorComponent } from './entity-forms/school-selector/school-selector.component';
import { SchoolSettingsComponent } from './entity-forms/school-settings/school-settings.component';
import { SchoolStripeComponent } from './entity-forms/school-stripe/school-stripe.component';
import { SettingsComponent } from './entity-forms/settings/settings.component';
import { TaxCertificateFormComponent } from './entity-forms/tax-certificate-form/tax-certificate-form.component';
import { UsersSelectorComponent } from './entity-forms/users-selector/users-selector.component';
import { EventsBookingYearComponent } from './events/events-booking-year/events-booking-year.component';
import { EventsBookingComponent } from './events/events-booking/events-booking.component';
import { EventsHistoryComponent } from './events/events-history/events-history.component';
import { FilterComponent } from './filter/filter.component';
import { BackButtonComponent } from './form-controls/back-button/back-button.component';
import { BasicInputComponent } from './form-controls/basic-input/basic-input.component';
import { GenericButtonComponent } from './form-controls/generic-button/generic-button.component';
import { CheckboxGroupComponent } from './form-controls/generic-checkboxes/checkbox-group/checkbox-group.component';
import { CheckboxComponent } from './form-controls/generic-checkboxes/checkbox/checkbox.component';
import { GenericCheckboxComponent } from './form-controls/generic-checkboxes/generic-checkbox/generic-checkbox.component';
import { GenericRadioCheckboxComponent } from './form-controls/generic-radio-checkbox/generic-radio-checkbox.component';
import { GenericSelectComponent } from './form-controls/generic-select/generic-select.component';
import { PasswordInputComponent } from './form-controls/password-input/password-input.component';
import { SensitiveInputComponent } from './form-controls/sensitive-input/sensitive-input.component';
import { SwitchInputComponent } from './form-controls/switch-input/switch-input.component';
import { TimeRangeInputComponent } from './form-controls/time-range-input/time-range-input.component';
import { FormErrorsComponent } from './form-errors/form-errors.component';
import { GardesComponent } from './gardes/gardes.component';
import { InfobulleComponent } from './infobulle/infobulle.component';
import { LangSelectorComponent } from './lang-selector/lang-selector.component';
import { LoaderComponent } from './loader/loader.component';
import { LogoComponent } from './logo/logo.component';
import { MiniLoaderComponent } from './mini-loader/mini-loader.component';
import { WanaModalComponent } from './modal-v2/modal.component';
import { ConfirmChangeMonthModalComponent } from './modals/confirm-change-month-modal/confirm-change-month-modal.component';
import { DisableMonthModalComponent } from './modals/disable-month-modal/disable-month-modal.component';
import { EventsActivationModalComponent } from './modals/events-activation-modal/events-activation-modal.component';
import { PreventBackModalComponent } from './modals/prevent-back-modal/prevent-back-modal.component';
import { NgMultiSelectComponent } from './ng-multi-select/ng-multi-select.component';
import { QuoteGeneratorComponent } from './quote-generator/quote-generator.component';
import { SearchComponent } from './search/search.component';
import { StripeCardFormComponent } from './stripe-card-form/stripe-card-form.component';
import { StripeComponent } from './stripe/stripe.component';
import { SubHeaderComponent } from './sub-header/sub-header.component';

export const componentsShared: any[] = [
    BasicInputComponent,
    GenericButtonComponent,
    PasswordInputComponent,
    GenericRadioCheckboxComponent,
    GenericSelectComponent,
    SwitchInputComponent,
    LogoComponent,
    LangSelectorComponent,
    QuoteGeneratorComponent,
    SubHeaderComponent,
    FormErrorsComponent,
    PersonalDataComponent,
    GeneralDataComponent,
    AddressComponent,
    RoleComponent,
    EducationLevelComponent,
    SchoolSelectorComponent,
    SchoolSettingsComponent,
    SettingsComponent,
    UsersSelectorComponent,
    SchedulesComponent,
    TimeRangeInputComponent,
    LoaderComponent,
    AdminDataComponent,
    SingleAddressContainerComponent,
    MultiAddressContainerComponent,
    SearchComponent,
    GardesComponent,
    InfobulleComponent,
    BackButtonComponent,
    CollapsibleContainerComponent,
    PasswordComponent,
    SchoolStripeComponent,
    EventsBookingComponent,
    EventsBookingYearComponent,
    EventsHistoryComponent,
    StripeComponent,
    StripeCardFormComponent,
    MiniLoaderComponent,
    SensitiveInputComponent,
    NgMultiSelectComponent,
    BasicSearchComponent,
    CheckboxGroupComponent,
    CheckboxComponent,
    GenericCheckboxComponent,
    TaxCertificateFormComponent,
    ImportContactsComponent,
    SchoolImportsComponent,
    WanaModalComponent,
    FilterComponent,
    PreventBackModalComponent,
    DisableMonthModalComponent,
    ConfirmChangeMonthModalComponent,
    EventsActivationModalComponent,
];

export * from './basic-search/basic-search.component';
export * from './collapsible-container/collapsible-container.component';
export * from './entity-forms/addresses/address/address.component';
export * from './entity-forms/addresses/multi-address-container/multi-address-container.component';
export * from './entity-forms/addresses/single-address-container/single-address-container.component';
export * from './entity-forms/education-level/education-level.component';
export * from './entity-forms/general-data/general-data.component';
export * from './entity-forms/import-contacts/import-contacts.component';
export * from './entity-forms/password/password.component';
export * from './entity-forms/personal-data/personal-data.component';
export * from './entity-forms/role/role.component';
export * from './entity-forms/schedules/schedules.component';
export * from './entity-forms/school-imports/school-imports.component';
export * from './entity-forms/school-selector/school-selector.component';
export * from './entity-forms/school-settings/school-settings.component';
export * from './entity-forms/school-stripe/school-stripe.component';
export * from './entity-forms/settings/settings.component';
export * from './entity-forms/tax-certificate-form/tax-certificate-form.component';
export * from './entity-forms/users-selector/users-selector.component';
export * from './events/events-booking-year/events-booking-year.component';
export * from './events/events-booking/events-booking.component';
export * from './events/events-history/events-history.component';
export * from './filter/filter.component';
export * from './form-controls/back-button/back-button.component';
export * from './form-controls/basic-input/basic-input.component';
export * from './form-controls/generic-button/generic-button.component';
export * from './form-controls/generic-checkboxes/checkbox-group/checkbox-group.component';
export * from './form-controls/generic-checkboxes/checkbox/checkbox.component';
export * from './form-controls/generic-checkboxes/generic-checkbox/generic-checkbox.component';
export * from './form-controls/generic-radio-checkbox/generic-radio-checkbox.component';
export * from './form-controls/generic-select/generic-select.component';
export * from './form-controls/password-input/password-input.component';
export * from './form-controls/sensitive-input/sensitive-input.component';
export * from './form-controls/switch-input/switch-input.component';
export * from './form-controls/time-range-input/time-range-input.component';
export * from './form-errors/form-errors.component';
export * from './infobulle/infobulle.component';
export * from './lang-selector/lang-selector.component';
export * from './loader/loader.component';
export * from './logo/logo.component';
export * from './mini-loader/mini-loader.component';
export * from './modal-v2/modal.component';
export * from './modals/confirm-change-month-modal/confirm-change-month-modal.component';
export * from './modals/disable-month-modal/disable-month-modal.component';
export * from './modals/prevent-back-modal/prevent-back-modal.component';
export * from './modals/events-activation-modal/events-activation-modal.component';
export * from './ng-multi-select/ng-multi-select.component';
export * from './quote-generator/quote-generator.component';
export * from './search/search.component';
export * from './stripe-card-form/stripe-card-form.component';
export * from './stripe/stripe.component';
export * from './sub-header/sub-header.component';
